import React, { ComponentProps, useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FaTimesCircle } from 'react-icons/fa';

type Props = React.PropsWithoutRef<ComponentProps<typeof Button>>;

const ButtonCancel = (props: Props) => {
  const { t, i18n } = useTranslation();

  return (
    <Button
      {...props}
      style={{ width: '160px' }}
      variant="danger"
      onClick={props.onClick}
    >
      <FaTimesCircle className="mb-1" />
      &nbsp;
      {i18n.language === 'gr' ? t('Ακύρωση') : t('Cancel')}
    </Button>
  );
};

export default React.memo(ButtonCancel);
